export const lend = {
  title: 'Shipping for customer',
}
